/* eslint-disable @typescript-eslint/no-non-null-assertion */
import type {
  SegmentationAnnotationStyles,
  SegmentationCoordinate,
} from '../types';

/**
 * Draws a segmentation path on a canvas context
 *
 * @param ctx - The 2D rendering context of the canvas
 * @param coordinates - Array of coordinate points [[x, y], [x, y], ...]
 * @param options - Optional drawing settings
 */
export function drawSegmentation(input: {
  coordintate: SegmentationCoordinate;
  styles: SegmentationAnnotationStyles;
  context: CanvasRenderingContext2D;
  scale?: number;
}) {
  const {
    coordintate: { coordinates },
    styles,
    context,
    scale = 1,
  } = input;

  if (!coordinates || coordinates.length === 0) return;

  if (styles.strokeColor) {
    context.strokeStyle = styles.strokeColor;
  }
  if (styles.strokeWidth) {
    context.lineWidth = styles.strokeWidth;
  }
  if (styles.strokeDashArray) {
    context.setLineDash(styles.strokeDashArray);
  }

  // Create pattern for dashed fill if fillDashArray is specified
  if (styles.fillDashArray && styles.fillColor) {
    const patternCanvas = document.createElement('canvas');
    const patternSize = Math.max(...styles.fillDashArray) * 2;
    patternCanvas.width = patternSize;
    patternCanvas.height = patternSize;
    const patternCtx = patternCanvas.getContext('2d');

    if (patternCtx) {
      patternCtx.strokeStyle = styles.fillColor;
      patternCtx.lineWidth = Math.max(1, styles.strokeWidth || 1);
      patternCtx.setLineDash(styles.fillDashArray);

      // Draw diagonal lines for the pattern
      patternCtx.beginPath();
      patternCtx.moveTo(0, 0);
      patternCtx.lineTo(patternSize, patternSize);
      patternCtx.stroke();

      const pattern = context.createPattern(patternCanvas, 'repeat');
      if (pattern) {
        context.fillStyle = pattern;
      }
    }
  } else {
    context.fillStyle = styles.fillColor;
  }

  context.beginPath();

  context.moveTo(coordinates[0]![0]! * scale, coordinates[0]![1]! * scale);

  for (let i = 1; i < coordinates.length; i++) {
    context.lineTo(coordinates[i]![0]! * scale, coordinates[i]![1]! * scale);
  }

  if (closed) {
    context.closePath();
  }

  context.fill();
  if (!styles.noStroke) {
    context.stroke();
  }
}
